export default function HeroSection() {
  return (
    <section className="relative w-full h-[75vh] min-h-[600px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/c197a4e2a06b7f1a35ec4acbb5cf4620.jpg"
        alt="Dog-friendly hiking in Highlands NC with scenic trails and waterfalls"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55" />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Local Pet Guide</p>
        <h1 className="font-cormorant text-6xl md:text-7xl text-white font-light leading-none mb-6">
          Dog-Friendly<br /><em className="italic">Highlands NC</em>
        </h1>
        <p className="text-white/75 font-jost text-base leading-relaxed max-w-2xl">
          Highlands, North Carolina is one of the most dog-friendly mountain towns in the Southeast — with scenic hiking trails, waterfall walks, welcoming restaurant patios, and pet-friendly places to stay.
        </p>
      </div>
    </section>
  );
}
